import { render, staticRenderFns } from "./venueSite.vue?vue&type=template&id=6a356953"
import script from "./venueSite.vue?vue&type=script&lang=js"
export * from "./venueSite.vue?vue&type=script&lang=js"
import style0 from "./venueSite.vue?vue&type=style&index=0&id=6a356953&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports